import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/serviceWorkerRegistration";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // NOTE: intentionally NOT wrapped in <React.StrictMode> — its dev-mode double-invoke
  // of effects (mount -> unmount -> mount) causes LiveKit meeting rooms to briefly
  // connect/disconnect/reconnect on every mount. The mitigations in useLiveKitMeeting.js
  // reduce but don't fully eliminate the resulting race (a real cause of users getting
  // auto-removed from a live meeting). Production builds never double-invoke regardless
  // of StrictMode, so removing it here only affects (and fixes) local/preview dev testing.
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);

registerServiceWorker();
